export default __webpack_public_path__ + "static/firstImg-dc5510a57c125e629a56a928b15cb054.png";